import React, { CSSProperties, FC } from 'react';
import styles from './Check.module.css';

export interface CheckProps {
  checkStyle?: CSSProperties;
}

const Check: FC<CheckProps> = ({ checkStyle = {} }) => (
  <svg
    className={styles.svg}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 12"
    style={checkStyle}
  >
    <path d="M12.7967 0.292892L14.5485 2.04478L4.88621 11.7071L0 6.82089L1.75188 5.06901L4.88621 8.20334L12.7967 0.292892Z" />
  </svg>
);

export default Check;
